import React, { FunctionComponent, useCallback } from 'react';

import { TooltipStateful } from '@yandex-360/orb-components/dist/components/Tooltip';
import cn from 'classnames';

import Button from '../../../../shared/components/button';
import SvgImage from '../../../../shared/components/svg-image';
import { useBooleanStateAutoResetByTimer } from '../../../../shared/hooks/useBooleanStateAutoResetByTimer';
import css from './index.css';

interface CopyButtonProps {
    onClick: () => void;
    title: string;
    testId?: string;
    className?: string;
}

const SvgCopyIcon = (
    <>
        <SvgImage className={css.CopyIcon} imageName="copy" />
        <SvgImage noContainer className={css.OkIcon} imageName="checkmark" />
    </>
);

export const CopyButton: FunctionComponent<CopyButtonProps> = ({
    onClick,
    title,
    testId,
    className,
}: CopyButtonProps) => {
    const [isOkShowed, setIsOkShowed] = useBooleanStateAutoResetByTimer(1500);

    const clickHandler = useCallback(() => {
        setIsOkShowed(true);
        onClick();
    }, [onClick, setIsOkShowed]);

    return (
        <TooltipStateful content={title} trigger="hover">
            <div>
                <Button
                    view="neutral"
                    pin="round-round"
                    testId={testId}
                    icon={SvgCopyIcon}
                    className={cn(className, css.CopyNumberButton, {
                        [css.CopyNumberButton_Toggled]: isOkShowed,
                    })}
                    onClick={clickHandler}
                    size="xs"
                />
            </div>
        </TooltipStateful>
    );
};
